export default __webpack_public_path__ + "static/media/Image1Mobile.f565da3d.png";